import { Params } from '@feathersjs/feathers';

export function paramsForServer(params1: Params = {}, ...whitelist: string[]) {
  const ifWhitelist = !!whitelist.length;
  const params: Params = Object.assign({}, params1);

  params.query = params.query || {};
  params.query.$client = params.query.$client || {};

  Object.keys(params).forEach(key => {
    if (key !== 'query') {
      if (!ifWhitelist || whitelist.includes(key)) {
        params.query.$client[key] = params[key];
      }

      delete params[key];
    }
  });

  return params;
}
